export default __webpack_public_path__ + "static/media/faq.f0efad2e.jpg";